
(() => {
  const run = () => {
    if (!window.location.pathname.includes('/policies/refund-policy')) return;

    const body = document.querySelector('.shopify-policy__body .rte') || document.querySelector('.shopify-policy__body');
    if (!body || body.dataset.questymeEditorial === 'true') return;

    const sectionTitles = new Set([
      'Return period and eligibility',
      'Non-returnable items',
      'Restocking fees and cancellations',
      'Return procedure (RMA)',
      'How much is refunded',
      'How and when refunds are paid',
      'Manufacturer warranty'
    ]);

    const source = body.innerHTML.replace(/<br\s*\/?>/gi, '\n');
    const temp = document.createElement('div');
    temp.innerHTML = source;
    const lines = (temp.textContent || '')
      .split(/\n+/)
      .map((line) => line.replace(/\s+/g, ' ').trim())
      .filter(Boolean);

    if (lines.length < 4) return;

    const fragment = document.createDocumentFragment();
    let paragraph = [];
    let currentList = null;
    let lastLi = null;
    let special = null;

    const appendParagraph = (text, className = '') => {
      const p = document.createElement('p');
      if (className) p.className = className;
      p.textContent = text;
      fragment.appendChild(p);
    };

    const flushParagraph = () => {
      if (!paragraph.length) return;
      appendParagraph(paragraph.join(' '));
      paragraph = [];
    };

    const closeList = () => {
      currentList = null;
      lastLi = null;
    };

    const startList = (tag) => {
      if (!currentList || currentList.tagName !== tag.toUpperCase()) {
        closeList();
        currentList = document.createElement(tag);
        fragment.appendChild(currentList);
      }
      return currentList;
    };

    const flushSpecial = () => {
      if (!special) return;
      appendParagraph(special.parts.join(' '), special.className);
      special = null;
    };

    for (const originalLine of lines) {
      const line = originalLine.trim();
      if (!line || line === 'Return & Refund Policy') continue;

      if (special) {
        special.parts.push(line);
        if (/[.!?]$/.test(line)) flushSpecial();
        continue;
      }

      if (/^Effective July 2009/i.test(line)) {
        flushParagraph();
        closeList();
        appendParagraph(line, 'policy-meta');
        continue;
      }

      if (sectionTitles.has(line)) {
        flushParagraph();
        flushSpecial();
        closeList();
        const h2 = document.createElement('h2');
        h2.textContent = line;
        fragment.appendChild(h2);
        continue;
      }

      if (line.startsWith('Where a signed contract or government purchase order')) {
        flushParagraph();
        closeList();
        special = { className: 'policy-callout', parts: [line] };
        if (/[.!?]$/.test(line)) flushSpecial();
        continue;
      }

      if (line.startsWith('Customers are responsible for return shipping and insurance')) {
        flushParagraph();
        closeList();
        special = { className: 'policy-callout', parts: [line] };
        if (/[.!?]$/.test(line)) flushSpecial();
        continue;
      }

      if (line.startsWith('This policy does not limit any rights')) {
        flushParagraph();
        closeList();
        special = { className: 'policy-footnote', parts: [line] };
        if (/[.!?]$/.test(line)) flushSpecial();
        continue;
      }

      const bullet = line.match(/^•\s*(.+)$/);
      if (bullet) {
        flushParagraph();
        const list = startList('ul');
        lastLi = document.createElement('li');
        lastLi.textContent = bullet[1];
        list.appendChild(lastLi);
        continue;
      }

      const numbered = line.match(/^\d+\.\s*(.+)$/);
      if (numbered) {
        flushParagraph();
        const list = startList('ol');
        lastLi = document.createElement('li');
        lastLi.textContent = numbered[1];
        list.appendChild(lastLi);
        continue;
      }

      if (currentList && lastLi) {
        const existing = lastLi.textContent.trim();
        const likelyNewParagraph = /[.!?]$/.test(existing) && /^[A-Z]/.test(line);
        if (!likelyNewParagraph) {
          lastLi.append(document.createTextNode(' ' + line));
          continue;
        }
        closeList();
      }

      paragraph.push(line);
    }

    flushSpecial();
    flushParagraph();

    body.innerHTML = '';
    body.appendChild(fragment);
    body.dataset.questymeEditorial = 'true';
    document.documentElement.classList.add('questyme-policy-editorial');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
